import { render, staticRenderFns } from "./SubjectLabelFilter.vue?vue&type=template&id=2a0428c0&"
import script from "./SubjectLabelFilter.ts?vue&type=script&lang=ts&"
export * from "./SubjectLabelFilter.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports